import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ITracker } from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { IPageTitleChip } from '../../../../../componentes/page-title/page-title.component';
import { ParamsService } from '../../../../../auxiliares/servicios/params.service';
import { CrearEditarTrackerComponent } from '../crear-editar-tracker/crear-editar-tracker.component';

@Component({
  selector: 'app-detalles-trackers',
  templateUrl: './detalles-trackers.component.html',
  styleUrl: '../../../../../componentes/detalle/detalle-pagina.scss',
  standalone: false,
})
export class DetallesTrackersComponent implements OnInit, OnDestroy {
  helper = inject(HelperService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private lista2 = inject(Lista2Service);
  private formularios = inject(FormularioDialogService);
  private paramsService = inject(ParamsService);

  public selectedTab = 0;
  public puedeEditar = this.helper.tienePermiso(
    'Administración - Editar trackers',
  );
  public idTracker: string = '';
  public tracker: ITracker;
  public tracker$: Subscription;

  public loading = true;
  public chips: IPageTitleChip[] = [];

  public tabChanged(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: this.selectedTab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  private setChips(): void {
    const chips: IPageTitleChip[] = [];

    if (this.tracker?.cliente?.nombre) {
      chips.push({
        label: this.tracker.cliente.nombre,
        icon: 'business',
      });
    }

    this.chips = chips;
  }

  public async listarTracker(): Promise<void> {
    this.tracker$?.unsubscribe();
    this.tracker$ = this.lista2.tracker(this.idTracker, 30).subscribe({
      next: (data) => {
        this.tracker = data;
        // El primer dato llega después de ngOnInit: los chips se arman acá o
        // quedan con el tracker vacío
        this.setChips();
        this.loading = false;
      },
      // Sin tracker: Info muestra "No se encontró" en vez del esqueleto
      error: () => (this.loading = false),
    });
  }

  public editar(): void {
    this.paramsService.setParams({ tracker: this.tracker });
    this.formularios
      .abrir(CrearEditarTrackerComponent, { tamano: 'grande' })
      .afterClosed()
      .subscribe(async (res) => {
        if (!res) return;
        // Refrescar ya: el polling del getById es cada 30s
        await this.listarTracker();
      });
  }

  async ngOnInit(): Promise<void> {
    const params = await firstValueFrom(this.activatedRoute.paramMap);
    this.idTracker = params.get('id');
    await this.listarTracker();
    this.setChips();

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['tab']) {
        this.selectedTab = parseInt(params['tab']);
      }
    });
  }

  ngOnDestroy(): void {
    this.tracker$?.unsubscribe();
  }
}
